import React, {Component} from 'react';
import AgendaPoll from '../../molecules/AgendaPoll';
import Poll from '../../molecules/Poll';

class Polls extends Component {

  render() {
    const {polls, userId} = this.props;
    return (
      <div className="Polls">

        {Object.keys(polls).map(pollId => {
          const poll = polls[pollId];
          const {type} = poll;

          const wrap = (children) => {
            return (
              <div key={pollId}>
                {children}
              </div>
            );
          };

          switch(type) {
            case 'dates':
              return wrap(<AgendaPoll userId={userId} id={pollId} />);
            default:
              return wrap(<Poll userId={userId} id={pollId} />);
          }

        })}

      </div>
    );

  }

};

export default Polls;



// WEBPACK FOOTER //
// ./src/component/organisms/Polls/component.js